export default [
  {
    key: "multiple",
    ignore: true
  },
  {
    type: "datagrid",
    input: true,
    label: "Questions",
    key: "questions",
    tooltip: "The questions you would like to ask in this survey question.",
    weight: 0,
    reorder: true,
    defaultValue: [{ label: "", value: "" }],
    validate: {
      custom: `
        if (!input || !Array.isArray(input)) {
          valid = true;
        } else {
          const hasEmptyValue = input.some(item => item.value === '' || item.value === undefined || item.value === null);
          if (hasEmptyValue) {
            valid = 'All questions must have a value. Please ensure each question has a non-empty value.';
          } else {
            const values = input.map(item => item.value);
            const uniqueValues = new Set(values);
            if (values.length !== uniqueValues.size) {
              valid = 'Question values must be unique. Please ensure each question has a distinct value.';
            } else {
              valid = true;
            }
          }
        }
      `
    },
    components: [
      {
        label: "Label",
        key: "label",
        input: true,
        type: "textfield"
      },
      {
        label: "Value",
        key: "value",
        input: true,
        type: "textfield",
        allowCalculateOverride: true,
        calculateValue: { _camelCase: [{ var: "row.label" }] }
      },
      {
        label: "Tooltip",
        key: "tooltip",
        input: true,
        type: "textfield"
      }
    ]
  },
  {
    type: "datagrid",
    input: true,
    label: "Values",
    key: "values",
    tooltip: "The values that can be selected per question. Example: 'Satisfied', 'Very Satisfied', etc.",
    weight: 1,
    reorder: true,
    defaultValue: [{ label: "", value: "" }],
    validate: {
      custom: `
        if (!input || !Array.isArray(input)) {
          valid = true;
        } else {
          const hasEmptyValue = input.some(item => item.value === '' || item.value === undefined || item.value === null);
          if (hasEmptyValue) {
            valid = 'All answers must have a value. Please ensure each answer option has a non-empty value.';
          } else {
            const values = input.map(item => item.value);
            const uniqueValues = new Set(values);
            if (values.length !== uniqueValues.size) {
              valid = 'Answer values must be unique. Please ensure each answer option has a distinct value.';
            } else {
              valid = true;
            }
          }
        }
      `
    },
    components: [
      {
        label: "Label",
        key: "label",
        input: true,
        type: "textfield"
      },
      {
        label: "Value",
        key: "value",
        input: true,
        type: "textfield",
        allowCalculateOverride: true,
        calculateValue: { _camelCase: [{ var: "row.label" }] }
      },
      {
        label: "Tooltip",
        key: "tooltip",
        input: true,
        type: "textfield"
      }
    ]
  }
];
